export class UserNotFoundException extends Error {}
export class NotVerifiedUserException extends Error {}
export class NotAcceptedUserPasswordException extends Error {}
export class UserAlreadyRegistrated extends Error {}
